import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { NumericInput } from "components/NumericInput/NumericInput";
import { FormikValues, useFormikContext } from "formik";
import {
  findOptionInGroups,
  getGroupedCountryOptionsByUuid,
} from "utils/stateRequired";
import { Countries } from "types/Models/countries";

export const ShareholderRoleFields = ({
  countries,
}: {
  countries?: Countries[];
}) => {
  const { values } = useFormikContext<FormikValues>();
  const countryOptions = getGroupedCountryOptionsByUuid(countries);

  return (
    <div className="t-flex t-flex-col t-gap-3 t-rounded t-bg-surface-lighter-grey t-p-4">
      <div className="t-text-subtext-sm t-text-text-60">Shareholder</div>
      <div className="t-grid t-grid-cols-2 t-gap-3">
        <NumericInput
          fieldProps={{ name: "shareholder.issuedCommonStock" }}
          storeNumeric
          numericProps={{
            customSize: "small",
            decimalScale: 0,
            allowNegative: false,
          }}
          label="Issued Common Stock"
        />
        <NumericInput
          fieldProps={{ name: "shareholder.issuedPreferredStock" }}
          storeNumeric
          numericProps={{
            customSize: "small",
            decimalScale: 0,
            allowNegative: false,
          }}
          label="Issued Preferred stock"
        />
      </div>
      <NumericInput
        fieldProps={{ name: "shareholder.ownershipPercentage" }}
        storeNumeric
        numericProps={{
          customSize: "small",
          fixedDecimalScale: true,
          decimalScale: 2,
          suffix: " %",
          allowNegative: false,
          isAllowed: ({ floatValue }) =>
            floatValue === undefined || floatValue <= 100,
        }}
        label="Ownership percentage"
        required
      />
      <Combobox
        label="Tax residency"
        placeholder="Select country"
        required
        withForm
        name="shareholder.countryId"
        options={countryOptions}
        value={findOptionInGroups(countryOptions, values.shareholder.countryId)}
        menuPortalTarget={document.body}
      />
    </div>
  );
};
